<template>
    <div class="">
		<div id="swagger"></div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            specs: null,
        }
    },
    async mounted() {
        try {
            const cachebuster = new Date().getTime();
			
			var swaggerUIOptions = {
				url: 'https://getcloudcast.com/OpenAPI_latest.json?cb=1?cb='+cachebuster,
				dom_id: '#swagger', // Determine what element to load swagger ui
				docExpansion: 'list',
				deepLinking: true, // Enables dynamic deep linking for tags and operations
				filter: true,
				presets: [
					SwaggerUIBundle.presets.apis,
					SwaggerUIBundle.SwaggerUIStandalonePreset
				],
				plugins: [
					SwaggerUIBundle.plugins.DownloadUrl
				],
			}

			var ui = SwaggerUIBundle(swaggerUIOptions)

			/** Export to window for use in custom js */
			window.ui = ui
        } 
        catch (e) {
            console.log('error', e);
        }
		
		
    }
}
</script>

<style lang="scss" >
.swagger-ui {
    h2 {
        @apply font-bold;
        @apply text-4xl;
    }
}
</style>
